import { useTheme } from '@emotion/react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import NavigationV2 from '@segment/templates/Navigation2'

import GettingStarted from '@segment/templates/GettingStarted'

import LayoutBase from '@segment/next-shared/layout'

import Hero from './components/Hero'
import LogoCarousel from './components/LogoCarousel'
import BreakdownSilosBetweenTeams from './components/BreakdownSilosBetweenTeams'
import CreateSingleViewOfTheCustomer from './components/CreateSingleViewOfTheCustomer'
import PersonalizeAcrossSitesAppsChannels from './components/PersonalizeAcrossSitesAppsChannels'
import EnableDataDrivenDecisionMaking from './components/EnableDataDrivenDecisionMaking'
import EmpowerHighPerformanceTeams from './components/EmpowerHighPerformanceTeams'
import Resources from './components/Resources'

import ogImagePng from './assets/OgSegmentIndustryEnterprise.png'

const IndustryEnterpriseView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="Industry: Enterprise | Twilio Segment"
        pageDescription="Twilio Segment is a customer data platform (CDP) that helps you collect, clean, and activate your customer data."
        pageOG={ogImagePng}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <NavigationV2 />
        <main>
          <Hero />
          <LogoCarousel />
          <BreakdownSilosBetweenTeams />
          <CreateSingleViewOfTheCustomer />
          <PersonalizeAcrossSitesAppsChannels />
          <EnableDataDrivenDecisionMaking />
          <EmpowerHighPerformanceTeams />
          <Resources />
          <GettingStarted />
        </main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

export default IndustryEnterpriseView
